exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_1aLG4 {\n    padding: 0 80px;\n}\n\n.infoContainer_1aLG4 > h3 {\n    text-align: center;\n    font-weight: 800;\n}\n\n.conditionsContainer_3z9Q6 {\n    padding-top: 5px;\n}\n\n.gapSection15_1KBpj {\n    height: 55px;\n}\n\n.sectionContainer_38UJY {\n    padding-top: 0px;\n}\n\n.emptyContainer_f9qjj {\n    padding-top: 100px;\n}\n\n.signatureSize_1sK32 img {\n    width: 200px;\n    height: 80px;\n}\n\n.centerText_1qqcB {\n    text-align: center;\n}", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_1aLG4",
	"conditionsContainer": "conditionsContainer_3z9Q6",
	"gapSection15": "gapSection15_1KBpj",
	"sectionContainer": "sectionContainer_38UJY",
	"emptyContainer": "emptyContainer_f9qjj",
	"signatureSize": "signatureSize_1sK32",
	"centerText": "centerText_1qqcB"
};